import './styles/text.css'

export default function Text({customClass = 'none',color = 'white',text}) {
  return (
    <div style={{color:color}} className={`text ${customClass}`}>
      {text}
    </div>
  )
}
